import { PublicClientApplication, LogLevel } from "@azure/msal-browser";
import { getCurrentEnvironment } from './constants/api';


export const API_SCOPES = ['openId','profile'];


export const msalConfig = {
  auth: {
    clientId: getCurrentEnvironment().clientId,
    authority: "https://login.microsoftonline.com/72446be9-a454-4bfa-87d4-8cf4f6eaaf39",
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  system: {
    loggerOptions: {
      logLevel: LogLevel.Verbose,
      piiLoggingEnabled: false,
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        if (level === LogLevel.Error) console.error("[MSAL]", message);
        else if (level === LogLevel.Warning) console.warn("[MSAL]", message);
        else if (level === LogLevel.Info) console.info("[MSAL]", message);
        else console.debug("[MSAL]", message);
      }
    }
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  }
};

export const msalInstance = new PublicClientApplication(msalConfig);

